import React from 'react';

import { cardGrid } from './CardGrid.css';

export interface CardGridProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  /**
   * Grid columns configuration
   * @default "auto-fill"
   */
  columns?: 'auto-fill' | 'auto-fit' | 2 | 3 | 4;
  /**
   * Gap between grid items
   * @default "medium"
   */
  gap?: 'small' | 'medium' | 'large';
}

export function CardGrid({ children, columns = 'auto-fill', gap = 'medium', className, ...props }: CardGridProps) {
  const combinedClassName = className ? `${cardGrid({ columns, gap })} ${className}` : cardGrid({ columns, gap });

  return (
    <div className={combinedClassName} {...props}>
      {children}
    </div>
  );
}
